<template>
  <div class="product-page-item" :class="[{ 'product-page-item_active': item.active }, accordionItemTypeClass]">
    <div class="product-page-item__inner">
      <b class="product-page-item__title" :class="{ 'product-page-item__title_clickable': !item.active }" @click="toggleAccordion">
        <LockIcon :published-to="item.publishedTo" />
        {{ title }}
      </b>
      <SlideUpDown :active="item.active" :duration="1000" ref="inner-accordion">
        <div class="product-page-item__col-holder" :class="accordionItemTemplateType">
          <div class="product-page-item__col" v-if="isContentPresent">
            <div class="product-page-item__content">
              <!-- you could have here vue-error -->
              <!-- The client-side rendered virtual DOM tree is not matching server-rendered content -->
              <!-- in case tags not closed in client data which we put in v-html -->
              <!-- to prevent user from this error we will render this item description part only on client side -->
              <ClientOnly>
                <p v-if="longDescr.external" class="product-page-item__info" v-html="longDescr.external"></p>
                <p v-if="longDescr.internal" class="product-page-item__info internal-information" v-html="longDescr.internal"></p>
                <p v-if="shortDescr.external" class="product-page-item__info" v-html="shortDescr.external"></p>
                <p v-if="shortDescr.internal" class="product-page-item__info internal-information" v-html="shortDescr.internal"></p>
                <p v-if="description.internal" class="product-page-item__info internal-information" v-html="description.internal"></p>
                <p v-if="descr.external" class="product-page-item__info" v-html="descr.external"></p>
                <p v-if="descr.internal" class="product-page-item__info internal-information" v-html="descr.internal"></p>
                <p
                  v-if="features.external || features.internal"
                  class="product-page-item__info sub-heading"
                  v-html="langJson[lang].features"
                ></p>
                <p v-if="features.external" class="product-page-item__info" v-html="features.external"></p>
                <p v-if="features.internal" class="product-page-item__info internal-information" v-html="features.internal"></p>
                <p
                  v-if="standardFittings.external || standardFittings.internal"
                  class="product-page-item__info sub-heading"
                  v-html="langJson[lang].standardFittings"
                ></p>
                <p v-if="standardFittings.external" class="product-page-item__info" v-html="standardFittings.external"></p>
                <p
                  v-if="standardFittings.internal"
                  class="product-page-item__info internal-information"
                  v-html="standardFittings.internal"
                ></p>
                <p
                  v-if="altFittings.external || altFittings.internal"
                  class="product-page-item__info sub-heading"
                  v-html="langJson[lang].alternativeFittings"
                ></p>
                <p v-if="altFittings.external" class="product-page-item__info" v-html="altFittings.external"></p>
                <p v-if="altFittings.internal" class="product-page-item__info internal-information" v-html="altFittings.internal"></p>
                <p v-if="endUserDescr.external" class="product-page-item__info" v-html="endUserDescr.external"></p>
                <p v-if="endUserDescr.internal" class="product-page-item__info internal-information" v-html="endUserDescr.internal"></p>
                <p v-if="notaBene.external" class="product-accordion__note" v-html="notaBene.external"></p>
                <p v-if="notaBene.internal" class="product-accordion__note" v-html="notaBene.internal"></p>
                <p v-if="erpCode" class="product-page-item__info internal-information" v-html="erpCode"></p>
                <p
                  v-if="calculation.external || calculation.internal"
                  class="product-page-item__info sub-heading"
                  v-html="langJson[lang].calculations"
                ></p>
                <p v-if="calculation.external" class="product-page-item__info" v-html="calculation.external"></p>
                <p v-if="calculation.internal" class="product-page-item__info internal-information" v-html="calculation.internal"></p>
                <p v-if="serviceInfo" class="product-page-item__info sub-heading" v-html="langJson[lang].serviceInformation"></p>
                <p v-if="serviceInfo" class="product-page-item__info service-information" v-html="serviceInfo"></p>
              </ClientOnly>
            </div>
          </div>
          <div class="product-page-item__col" v-if="isResourcesPresent">
            <div class="product-page-item__media-list">
              <div class="product-page-item__media-list-inner">
                <div
                  v-for="(resource, index) in Array.from(resources.values())"
                  class="product-page-item__media-item"
                  :class="`product-page-item__media-item_${privacyTypeSlugs[resource.item.publishedTo]}`"
                  :key="'resource_' + index"
                >
                  <template v-if="item.productBlockType !== 'ProductCard'">
                    <div class="product-page-item__media-item-inner">
                      <LockIcon :published-to="resource.item.publishedTo" />
                      <div class="product-page-item__media-holder">
                        <div class="product-page-item__media-box">
                          <template v-if="resource.item.type === resourceTypes.VIDEO">
                            <div class="product-page-item__player" @click="play(index, $event)">
                              <span class="icon-player product-page-item__player-icon"></span>
                              <video width="250" height="250" @ended="onEnd">
                                <source :src="baseUrlMedia + resource.item.fileId + '/' + resource.item.fileName" type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          </template>
                          <template v-else>
                            <img
                              :src="previewImagePath(resource.item)"
                              @error="handleImageError"
                              :alt="setProperFieldExternalFirst(resource.item, 'title') || 'image'"
                              class="product-page-item__image"
                            />
                          </template>
                        </div>
                      </div>
                      <div class="product-page-item__media-content">
                        <b class="product-page-item__media-title">
                          {{ setProperFieldExternalFirst(resource.item, 'title') }}
                        </b>
                      </div>
                      <div class="product-page-item__media-bottom-bar">
                        <product-downloads :resource="resource"></product-downloads>
                        <div class="product-page-item__media-details" @click="handleOpenProductDetails(resource, $event)">
                          <div class="product-page-item__media-details-button">
                            {{ langJson[lang].details }}
                            <i class="icon-arrow-right"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="product-page-item__media-box">
                      <img
                        :src="previewImagePath(resource.item)"
                        @error="handleImageError"
                        :alt="setProperFieldExternalFirst(resource.item, 'title') || 'image'"
                        class="product-page-item__image"
                      />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SlideUpDown>
      <div class="product-page-item__toggle-btn" @click="toggleAccordion">
        <div class="product-page-item__toggle-btn-inner">
          <span v-if="item.active">
            {{ langJson[lang].minimize }}
            <span class="product-page-item__minus"></span>
          </span>
          <span v-else>
            {{ langJson[lang].expand }}
            <span class="product-page-item__plus"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { handleImageError } from '~/utils/imageFallback';
  import { privacyTypeSlugs, resourceTypes, resourceDisplayPriority } from '@/constants/index.js';

  interface BaseResourceItem {
    fileId: string;
    fileName: string;
    mimeType: string;
    publishedTo: number;
    coverImageId?: string;
    coverImageName?: string;
    external?: {
      title?: string;
      [key: string]: any;
    };
    internal?: {
      title?: string;
      [key: string]: any;
    };
    title?: string;
  }

  interface ResourceItem extends BaseResourceItem {
    type?: string;
    extension: string;
  }

  interface ResourceCollection {
    item: ResourceItem;
    items: ResourceItem[];
  }

  interface ExternalInternal {
    external?: string;
    internal?: string;
  }

  interface ProductPageBlockItem {
    active?: boolean;
    publishedTo: number;
    productBlockType?: string;
    resources?: BaseResourceItem[];
    title?: string;
    external?: {
      [key: string]: any;
    };
    internal?: {
      [key: string]: any;
    };
    erpCode?: string;
    serviceInfo?: string;
    [key: string]: any;
  }

  const props = defineProps<{
    item: ProductPageBlockItem;
    index: number;
    allExpanded?: boolean;
  }>();

  const emit = defineEmits<{
    onToggle: [index: number];
  }>();

  const mainStore = useMainStore();
  const baseUrlMedia = computed(() => mainStore.baseUrlMedia);
  const langJson = computed(() => mainStore.langJson);
  const lang = computed(() => mainStore.lang);

  const imgRatio = '?width=300&height=300';
  const imgMaxSize = '&width=300&height=300';
  const filePreview = '/Preview?mimetype=image/jpg';

  function setProperFieldExternal(obj: any, field: string): string {
    return obj && obj.external ? obj.external[field] || '' : '';
  }
  function setProperFieldInternal(obj: any, field: string): string {
    return obj && obj.internal ? obj.internal[field] || '' : '';
  }
  function setProperFieldExternalFirst(obj: any, field: string): string {
    return obj && obj.external && obj.external[field]
      ? obj.external[field]
      : obj && obj.internal && obj.internal[field]
        ? obj.internal[field]
        : obj && obj[field]
          ? obj[field]
          : '';
  }

  const title = computed(() => setProperFieldExternalFirst(props.item, 'title'));
  const shortDescr = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'shortDescr'),
      internal: setProperFieldInternal(props.item, 'shortDescr')
    })
  );
  const description = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'description'),
      internal: setProperFieldInternal(props.item, 'description')
    })
  );
  const descr = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'descr'),
      internal: setProperFieldInternal(props.item, 'descr')
    })
  );
  const longDescr = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'longDescr'),
      internal: setProperFieldInternal(props.item, 'longDescr')
    })
  );
  const altFittings = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'altFittings'),
      internal: setProperFieldInternal(props.item, 'altFittings')
    })
  );
  const standardFittings = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'standardFittings'),
      internal: setProperFieldInternal(props.item, 'standardFittings')
    })
  );
  const features = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'features'),
      internal: setProperFieldInternal(props.item, 'features')
    })
  );
  const erpCode = computed(
    () =>
      props.item.erpCode ||
      (props.item.external && props.item.external.erpCode) ||
      (props.item.internal && props.item.internal.erpCode) ||
      ''
  );
  const serviceInfo = computed(
    () =>
      props.item.serviceInfo ||
      (props.item.external && props.item.external.serviceInfo) ||
      (props.item.internal && props.item.internal.serviceInfo) ||
      ''
  );
  const calculation = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'calculation'),
      internal: setProperFieldInternal(props.item, 'calculation')
    })
  );
  const endUserDescr = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'endUserDescr'),
      internal: setProperFieldInternal(props.item, 'endUserDescr')
    })
  );
  const notaBene = computed(
    (): ExternalInternal => ({
      external: setProperFieldExternal(props.item, 'notaBene'),
      internal: setProperFieldInternal(props.item, 'notaBene')
    })
  );

  function getLengthEvery(...args: (string | undefined)[]): number {
    return args.reduce((acc, x) => acc + (x ? x.length : 0), 0);
  }

  const isContentPresent = computed(
    () =>
      getLengthEvery(
        standardFittings.value.external,
        endUserDescr.value.external,
        description.value.external,
        altFittings.value.external,
        calculation.value.external,
        shortDescr.value.external,
        longDescr.value.external,
        features.value.external,
        notaBene.value.external,
        descr.value.external,
        shortDescr.value.internal,
        description.value.internal,
        descr.value.internal,
        longDescr.value.internal,
        altFittings.value.internal,
        standardFittings.value.internal,
        features.value.internal,
        calculation.value.internal,
        endUserDescr.value.internal,
        notaBene.value.internal,
        erpCode.value,
        serviceInfo.value
      ) > 0
  );

  const isResourcesPresent = computed(() => props.item && props.item.resources && props.item.resources.length > 0);

  function breakRefs(data: any): any {
    return JSON.parse(JSON.stringify(data));
  }

  function removeFileNameExtension(x: string): string {
    return x.replace(/\.[^/.]+$/, '');
  }
  function extractExtensionFromFileName(x: string): string {
    return x.split('.').pop() || '';
  }
  function getResourceType(mimeType: string, extension: string): string {
    const fileExtensions = ['pdf', 'dwg', 'doc', 'xls'];
    const videoMimeTypes = ['application/octet-stream'];
    if (mimeType.indexOf('image') > -1) {
      return resourceTypes.IMAGE;
    } else if (videoMimeTypes.includes(mimeType) && !fileExtensions.includes(extension)) {
      return resourceTypes.VIDEO;
    } else {
      return resourceTypes.FILE;
    }
  }

  function prepareResources(resources: BaseResourceItem[] | null): Map<string, ResourceCollection> {
    const map = new Map<string, ResourceCollection>();
    if (resources === null) return map;
    resources.forEach((item) => {
      if (item.fileName) {
        const resourceName = removeFileNameExtension(item.fileName);
        const extension = extractExtensionFromFileName(item.fileName);
        const collection = map.get(resourceName);
        const resourceWithExtension: ResourceItem = {
          ...item,
          extension,
          type: getResourceType(item.mimeType, extension)
        };
        if (!collection) {
          map.set(resourceName, {
            item: resourceWithExtension,
            items: [{ ...item, extension }]
          });
        } else {
          if (
            typeof resourceDisplayPriority !== 'undefined' &&
            resourceDisplayPriority.indexOf(extension) > resourceDisplayPriority.indexOf(collection.item.extension)
          ) {
            collection.item = resourceWithExtension;
            collection.items.unshift({ ...item, extension });
          } else {
            collection.items.push({ ...item, extension });
          }
        }
      }
    });
    return map;
  }

  const resources = computed(() => prepareResources(breakRefs(props.item.resources)));
  const displayedResourcesCount = computed(() => resources.value.size);

  const accordionItemTemplateType = computed(() => {
    let type = null;
    if (isResourcesPresent.value && isContentPresent.value) {
      if (displayedResourcesCount.value === 1) type = 'product-page-item__col-holder_wide-text';
      if (displayedResourcesCount.value === 2) type = 'product-page-item__col-holder_narrow-text';
      if (displayedResourcesCount.value > 2) type = 'product-page-item__col-holder_block-text';
    } else {
      if (isContentPresent.value) type = 'product-page-item__col-holder_only-content';
      if (isResourcesPresent.value) type = 'product-page-item__col-holder_only-resources';
    }
    return type;
  });

  const accordionItemTypeClass = computed(() => {
    let accordionItemType = props.item.publishedTo;
    switch (accordionItemType) {
      case 1:
        return 'product-page-item_external';
      case 2:
        return 'product-page-item_internal';
      case 3:
        return 'product-page-item_service';
      default:
        return '';
    }
  });

  function previewImagePath(file: ResourceItem): string {
    if (file.mimeType.indexOf('application') > -1) {
      return baseUrlMedia.value + file.fileId + '/' + file.fileName + filePreview + imgMaxSize;
    } else {
      return baseUrlMedia.value + file.fileId + '/' + file.fileName + imgRatio;
    }
  }

  function handleOpenProductDetails(resource: ResourceCollection, event: Event): void {
    let productResourceTitle =
      resource.item.external && resource.item.external.title ? resource.item.external.title : resource.item.internal?.title;
    if (window && (window as any).$gtm) {
      (window as any).$gtm.pushEvent({
        productResourceTitle: productResourceTitle,
        event: event
      });
    }
    // Open product details popup
    if (mainStore.openProductDetails) mainStore.openProductDetails(resource);
  }

  function filePreviewImagePath(file: ResourceItem): string {
    if (file.coverImageId && file.coverImageName) {
      return baseUrlMedia.value + file.coverImageId + '/' + file.coverImageName + filePreview + imgMaxSize;
    }
    return baseUrlMedia.value + file.fileId + '/' + file.fileName + filePreview + imgMaxSize;
  }

  function toggleAccordion(): void {
    emit('onToggle', props.index);
  }

  function play(index: number, event: Event): void {
    const target = event.target as HTMLElement;
    const video = target.querySelector('video') as HTMLVideoElement;
    if (video && video.paused) {
      target.classList.add('playing');
      video.play();
    } else if (video) {
      target.classList.remove('playing');
      video.pause();
    }
  }

  function onEnd(event: Event): void {
    const target = event.target as HTMLVideoElement;
    if (target?.parentNode) {
      (target.parentNode as HTMLElement).classList.remove('playing');
    }
  }
</script>
